<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>



<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row" *ngIf="SelectedpatientDetails">
          <div class="col-md-1 ">
            <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-4 padding-left-0px">
            <div class="row row-height-17px margin-left-0px">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.OwnerName}} </label>
              </div>
            </div>
            <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{SelectedpatientDetails.EggName}}) </label>
              </div>
            </div>
            <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
              </div>
            </div>-->
            <div class="row row-height-17px">
              <div class="col-md-12">
                
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerAgeYears}},{{SelectedpatientDetails.OwnerFormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerTelephone1}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-2 padding-right-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
              </div>
              <div class="col-md-9 padding-left-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
              </div>

            </div>

          </div>
          <div class="col-md-6  padding-right-0px">
            <!--<div class="row font-size-12px">
    <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
    </div>:
    <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
    </div>
  </div>-->
            <div class="row font-size-12px">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SemanAnalysis2">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SemanAnalysis2.ActivityStatus}}</label>
              </div>
            </div>
            <!--<div class="row font-size-12px" *ngIf="SelectedpatientDetails">
    <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">Insemination Date</label>
    </div>:
    <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SelectedpatientDetails">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SelectedpatientDetails.DateOfInsemination | date:'MMM-dd-yyyy'}}</label>
    </div>
  </div>-->
            <!--<div class="row font-size-12px" *ngIf="SelectedpatientDetails">
    <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">Insemination Time </label>
    </div>:
    <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="SelectedpatientDetails">
      <label class="font-weight-normal font-size-12px margin-bottom-0px">{{SelectedpatientDetails.DateOfInsemination | date: 'hh:mm a'}}</label>
    </div>
  </div>-->
            <!--<div class="row">
    <div class="col-md-1 margin-left-auto padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
      </div>
    <div class="col-md-1 padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
    </div>

     <div class="col-md-1 padding-left-7px">

      <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
    </div>

  </div>-->
            <div class="row margin-right-0px" hidden>
              <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
              </div>
              <div class="Dsa2" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
              </div>
              <div class="Dsa3" *ngIf="DSADetails">

                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.close('Load')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="card">
       
          <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
            <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
              <div class="col-md-6 padding-right-0px">
                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                  Cryo Preservation
                </label>
              </div>
              <div class="col-md-5  padding-right-0px " *ngIf="GradingModel &&  SelectedpatientDetails">
                <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                <div class="row float-right" *ngIf="GradingModel=='Well Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                  <div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgrading()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>

                <div class="row float-right" *ngIf="GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName!='Fet'">
                  <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                    
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                  </div>-->

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printgradingdroplet()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>
                <div class="row float-right" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && GradingModel=='Well Culture'">
                  <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                   
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                  </div>-->

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfet()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>
                <div class="row float-right" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && GradingModel=='Droplet Culture'">
                  <!--<div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="SemanAnalysis2">
                                        <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="GradingCheck()" title="Is Grading Completed" *ngIf="SemanAnalysis2.ActivityStatus !=='Completed'">Is Grading Completed</a>
                  </div>-->

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfet()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>
              </div>

            </div>
          </div>
          <div class="chatsd product-chart-wrapper product-chat-follicular-popup agreement-chart-wrapper ps  padding-lrt " data-ps-id="dfsfsde">
            <div class="card-body">
              <div class="accordion padding-top-10" id="accordionExampleEs">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingEs">
                    <div class="row">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseEs" aria-expanded="true" aria-controls="collapseEs">
                            Embryo Storage Table
                          </button>
                        </h5>
                      </div>
                      <div class="col-md-7 padding-right-0px" *ngIf="Frozen">

                        <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="AddEmbryotostore()" *ngIf="Frozen > 0">
                          Store Selected Embryos
                        </button>

                      </div>
                      <!--<div class="col-md-7 padding-right-0px">
            <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
              <ng-template  *ngIf="l.SelectedFreezeCount > 0">
                <button class="btn actions-btn-prime float-right font-size-15px " type="button" (click)="AddEmbryotostore()">
                  Store Selected Embryos
                </button>
              </ng-template>

            </ng-container>
          </div>-->
                    </div>


                  </div>

                  <div id="collapseEs" class="collapse show" aria-labelledby="headingEs" data-parent="#accordionExampleEs">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100pe">

                                <thead class="">
                                  <tr>
                                    <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Sno</th>
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>-->
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px">DOC</th>

                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Frozen Count</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Can Freeze Count</th>


                                    <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->

                                    <th class="padding-top-4px padding-bottom-4px font-size-12px">Select For Storage</th>


                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleController ; let RowIndex = index ">

                                    <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                    <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                                    <!--<td class="padding-top-4px padding-bottom-4px"></td>-->
                                    <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px text-align-center">
                                      {{l.DOC}}

                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                                      {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>

                                    <td class="padding-top-4px padding-bottom-4px">
                                      <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                                      <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px text-align-center"> {{l.NetFrozenCount}}</td>
                                    <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}} </td>
                                    <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                    <td class="padding-top-4px padding-bottom-4px">

                                      <input *ngIf="l.AvailableCount>0"
                                             type="checkbox" class="width-30px height-14px margin-top-3px display-inline" (ngModelChange)="dataChanged2($event,l)"
                                             [(ngModel)]="l.IsSelected" />
                                      <i class="input-helper"></i>

                                      <input type="text" class="form-control-patient width-34pe display-inline" placeholder=""
                                             [(ngModel)]="l.SelectedFreezeCount" [value]='Frozen' (keyup)="onKey(l.SelectedFreezeCount)"
                                             name="l.SelectedFreezeCount" #Frozen="ngModel"
                                             maxlength="100" required *ngIf="l.IsSelected">
                                      <label *ngIf="l.SelectedFreezeCount>l.AvailableCount" class="margin-bottom-0px">Error:</label> <label *ngIf="l.SelectedFreezeCount>l.AvailableCount" class="color-Rejected margin-bottom-0px margin-left-3px margin-top-3px">Reduce Selected Count</label>

                                    </td>
                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>



                    </div>
                  </div>
                </div>
              </div>

              <div class="accordion padding-top-10" id="accordionExampleCC">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingCC">
                    <div class="row">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseCC" aria-expanded="true" aria-controls="collapseCC">
                            Current Cycle
                          </button>
                        </h5>
                      </div>

                    </div>


                  </div>

                  <div id="collapseCC" class="collapse show" aria-labelledby="headingCC" data-parent="#accordionExampleCC">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100pe">

                                <thead class="">
                                  <tr>
                                    <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Sno</th>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">DOC</th>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>


                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Embryo Count</th>
                                    <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px">Select</th>-->


                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesController ; let RowIndex = index ">
                                    <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                    <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                                    <td class="padding-top-4px padding-bottom-4px">{{l.CycleNumber}}</td>
                                    <td class="padding-top-4px padding-bottom-4px padding-left-0px text-align-center">
                                      {{l.DOC}}

                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                                      {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                                    </td>

                                    <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>
                                    <td class="padding-top-4px padding-bottom-4px">
                                      <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                                      <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.EmbryoCount}}</td>

                                    <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                    <!--<td class="padding-top-4px padding-bottom-4px"><button class="btn actions-btn-prime font-size-13px margin-right-auto" (click)="SelectPresentstep1(l)">Select</button></td>-->
                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>



                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion" id="accordionExamplePC">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingPC">
                    <div class="row">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsePC" aria-expanded="true" aria-controls="collapsePC">
                            Previous Cycles
                          </button>
                        </h5>
                      </div>

                    </div>


                  </div>

                  <div id="collapsePC" class="collapse show" aria-labelledby="headingPC" data-parent="#accordionExamplePC">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-component">
                            <div class="table-responsive">


                              <table class="table table-striped margin-left-zero width-100pe">

                                <thead class="">
                                  <tr>
                                    <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Sno</th>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">DOC</th>
                                    <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>


                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                                    <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Embryo Count</th>
                                    <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                                    <!--<th class="padding-top-4px padding-bottom-4px font-size-12px">Select</th>-->


                                  </tr>
                                </thead>
                                <tbody class="table-body">

                                  <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesControllerByActor ; let RowIndex = index ">
                                    <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                                    <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                                    <td class="padding-top-4px padding-bottom-4px">{{l.CycleNumber}}</td>
                                    <td class="padding-top-4px padding-bottom-4px text-align-center padding-left-0px">
                                      {{l.DOC}}

                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                                      {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>

                                    <td class="padding-top-4px padding-bottom-4px">
                                      <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                                      <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                                    </td>
                                    <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.EmbryoCount}}</td>
                                    <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                                    <!--<td class="padding-top-4px padding-bottom-4px"><button class="btn actions-btn-prime font-size-13px margin-right-auto" (click)="SelectPresentstep1(l)">Select</button></td>-->
                                  </tr>
                                </tbody>

                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
